module.exports = __webpack_public_path__ + "static/media/cloud.cf1a3c2d.svg";